import {inject, Injectable} from '@angular/core';
import {getDownloadURL, getStorage, ref as storeRef, uploadBytes} from 'firebase/storage';
import {FirebaseInitService} from './firebase-init.service';
import {v6 as uuidv6} from 'uuid';
import {UserImage} from '@models';

type FirebaseStorage = ReturnType<typeof getStorage>;

@Injectable({
	            providedIn: 'root'
            })
export class UploadfileService {
	private readonly firebaseInit = inject(FirebaseInitService);

	private get storage(): FirebaseStorage | null {
		try {
			return this.firebaseInit.storage;
		} catch {
			// Storage non disponible (ex: dans les tests)
			return null;
		}
	}

	pushTchatImageGeneral(fileUpload: File, uid: string): Promise<UserImage> {
		return this.pushTchatImage(fileUpload, uid);
	}

	async pushTchatImage(fileUpload: File, uid: string): Promise<UserImage> {
		if (!this.storage) {
			throw new Error('Storage is not available');
		}

		const snapshot = await uploadBytes(
			storeRef(this.storage, `general-chat/${uuidv6()}/${uuidv6()}.jpg`),
			fileUpload
		);
		const downloadRUL = await getDownloadURL(snapshot.ref);
		return {
			user_uid: uid,
			name: fileUpload.name,
			url: downloadRUL,
			favorite: false
		};
	}
}
